import { EDropshippingProvider } from '@domain/enums/common/integrations/EDropshippingProvider';
import { IStoreIntegrations } from '@domain/interfaces/stores/IStores';

export const getDropshippingProviderIntegrationStatus = (
  storeIntegrations: IStoreIntegrations,
  identifier: EDropshippingProvider,
): boolean => {
  const foundStoreFrontIntegration = storeIntegrations.store_front?.find(
    integration => integration.name === identifier,
  );

  return Boolean(foundStoreFrontIntegration?.is_active);
};
